<template>
  <v-menu offset-y class="d-flex">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-if="!selectedStore" elevation="0" color="white" dark tile v-bind="attrs" v-on="on" class="black--text mx-0">
        {{ masterStore.name }}
        <v-icon class="ml-4">mdi-chevron-down</v-icon>
      </v-btn>
      <v-btn v-else elevation="0" color="white" dark tile v-bind="attrs" v-on="on" class="black--text mx-0">
        <v-avatar outlined size="36" class="mr-3">
          <v-img :src="selectedStore.logo"></v-img>
        </v-avatar>
        {{ selectedStore.name }}
        <v-chip 
          class="white--text font-weight-bold ml-4" 
          color="green" 
          small 
          label
          v-if="selectedStore.master && !hasWhitelabelId"
        >
          Master
        </v-chip>
        <v-icon class="ml-4">mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-card class="pa-2">
      <v-list class="pb-4 pt-0" v-if="masterStore">
        <v-subheader v-if="!hasWhitelabelId">Master</v-subheader>
        <v-list-item-group>
          <v-list-item 
            class="text-decoration-none" 
            :selected="masterStore.id == storeId"
            @click="$emit('select-store', masterStore.id)"
          >
            <v-list-item-avatar>
              <v-img :src="masterStore.logo"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-subtitle class="py-n4">{{ masterStore.name }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="!hasWhitelabelId">
              <v-chip class="white--text font-weight-bold" color="green" small label>Master</v-chip>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-list 
        style="white-space: nowrap; overflow-x: auto; height: 150px" 
        class="py-0"
        v-if="!hasWhitelabelId"
      >
        <v-subheader>{{ $t("headerDropDown.subStores") }}</v-subheader>
        <v-list-item-group>
          <template v-for="(store, index) in allStores">
            <v-list-item 
              :key="index" 
              class="py-1" 
              v-if="!store.master" 
              :selected="store.id == storeId"
              @click="$emit('select-store', store.id)"
            >
              <v-list-item-avatar>
                <v-img :src="store.logo"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-subtitle>{{ store.name }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'AppStoreSelector',
  props: {
    masterStore: {
      type: Object,
      default: () => ({})
    },
    selectedStore: {
      type: Object,
      default: null
    },
    allStores: {
      type: Array,
      default: () => []
    },
    storeId: {
      type: String,
      default: ''
    },
    hasWhitelabelId: {
      type: Boolean,
      default: false
    }
  }
}
</script>
